import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import type { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { getUrls } from "@portal/app/_common/lib/urls";
import { usePageContext } from "../../_components/context/PageContext";

const customerUrls = getUrls("CUSTOMER");

export const SignInInsteadDialog = ({
  onClose,
  open,
  isDreamSearch,
}: {
  onClose: (shouldOpenSignIn?: boolean) => void;
  open: boolean;
  isDreamSearch?: boolean;
}) => {
  const router = useRouter();
  const [loginOpen, setLoginOpen] = useState(false);
  const { mobileMatchMedia } = usePageContext();
  const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.only("xs"), mobileMatchMedia);

  useEffect(() => {
    if (!open && loginOpen) {
      setLoginOpen(false);
    }
  }, [loginOpen, open]);

  return (
    <Dialog onClose={() => onClose()} open={open}>
      <DialogTitle>
        This email or phone number already exists. Do you want to sign in instead?
      </DialogTitle>
      <DialogContent>
        <Button
          onClick={() => {
            if (isDreamSearch) {
              onClose(true);
            } else {
              return router.push(customerUrls.Login());
            }
          }}
          sx={{ margin: "auto" }}
          fullWidth={isXs}
        >
          Sign in
        </Button>
        <Box pt={2}>
          <Button
            onClick={() => onClose()}
            sx={{ margin: "auto" }}
            fullWidth={isXs}
            color="secondary"
          >
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
